export default __webpack_public_path__ + "static/media/Group1465101.b8b2aa6d.svg";